import React from 'react';

import {
  AutoCompleteField,
  MCButton,
  MCText,
  SearchTextField,
  ToggleSwitch
} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { addressObject, lang, remCss } from 'src/helpers';

import managerModel from './managerModel';
import ShortInfo from '../user/ShortInfo';
import PopupSelect from '../complex/popupSelect';
import GoogleMaps from './GoogleMaps';
import LANG_CONST from 'src/helpers/lang/const';
import MCVirtuoso from '../complex/MCVirtuoso';

const apiId = 'add';

export default class AddLocation extends BaseComponent {
  state = { step: 1 };
  componentDidMount() {
    const { model, addManager = false } = this.props;
    model.baseSubscribe(this.subscription);
    this.setState({ step: 1 });
    model.resetLocation();
    if (addManager) {
      managerModel.baseSubscribe(this.subscription);
      managerModel.reset(true);
      managerModel.refresh();
    }
  }

  componentWillUnmount() {
    const { model, addManager = false } = this.props;
    model.unsubscribe(this.subscription);
    if (addManager) managerModel.unsubscribe(this.subscription);
  }

  submit = (e) => {
    e.preventDefault();
    const { model, addManager = false, hide } = this.props;

    model.validRequest((valid) => {
      if (valid) {
        const managerAccess = {};
        for (let key in managerModel.state.managerAccess) {
          managerAccess[key] = {};
          Object.keys(LANG_CONST.constants.manager_access).forEach((v) => {
            const { active, ...access } = managerModel.state.managerAccess[key];
            if (active === false) {
              managerAccess[key][v] = false;
            } else {
              managerAccess[key][v] = !['customerSupport', 'doctors'].includes(v);
              if (access[v] !== undefined) {
                managerAccess[key][v] = access[v];
              }
            }
          });
        }
        model.saveDate(hide, addManager ? { managerAccess } : {});
      }
    });
  };

  renderStep1 = () => {
    const { model } = this.props;
    const createState = model.getApiState(apiId);
    const { invalid } = createState;
    const address = addressObject(
      model.state?.countryAddress ? model.state : model.user?.countryAddress ? model.user : {}
    );
    const { place, cityPlace } = model.getState();
    const isClinicDoctor = !!model.isClinicDoctor();
    invalid['otherHospital'] = invalid['hospital'];

    return (
      <form className='mc-modal-body mc-flex-15-col mc-grow' onSubmit={this.submit}>
        <AutoCompleteField
          template={5}
          label={LANG_CONST.address.country}
          name={'countryAddress'}
          isClearable={true}
          value={model.input('countryAddress')}
          onChange={(n, v) => {
            if (model.input('countryAddress') !== v) {
              model.handleChange(n, v);
              model.handleChange('stateAddress', '');
              model.handleChange('cityAddress', '');
              model.handleChange('hospital', '');
              model.handleChange('otherHospital', '');
              model.cancelApi('getPlace');
              model.setState({ place: null, cityPlace: null });
            }
          }}
          autocompleteApi='country'
          autocompleteParams={{
            limit: 300
          }}
          invalid={invalid}
        />
        <AutoCompleteField
          template={5}
          isClearable={true}
          label={LANG_CONST.address.state}
          name={'stateAddress'}
          value={model.input('stateAddress')}
          onChange={(n, v) => {
            model.handleChange(n, v);
            model.handleChange('cityAddress', '');
            model.handleChange('hospital', '');
            model.handleChange('otherHospital', '');
            model.cancelApi('getPlace');
            model.setState({ place: null, cityPlace: null });
          }}
          invalid={invalid}
          autocompleteParams={{
            countryCode: address.countryCode,
            limit: 100
          }}
          autocompleteApi='state'
        />
        <AutoCompleteField
          template={5}
          isClearable={true}
          label={LANG_CONST.address.city}
          name={'cityAddress'}
          value={model.input('cityAddress')}
          onChange={(n, v) => {
            if (v?.toString() === model.input('cityAddress')?.toString()) return;
            model.handleChange(n, v || '');
            model.handleChange('hospital', '');
            model.handleChange('otherHospital', '');
            model.cancelApi('getPlace');
            model.setState({ place: null });
            model.loadCityPlace(
              [
                model.input('countryAddress')?.split('_')[0],
                model.input('stateAddress')?.split('_')[0],
                model.input('cityAddress')?.split('_')[0]
              ].join(' ')
            );
          }}
          invalid={invalid}
          autocompleteApi='city'
          autocompleteParams={{
            countryCode: address.countryCode,
            stateCode: address.stateCode,
            limit: 20
          }}
        />
        <div className={'mc-flex-10-col'}>
          {isClinicDoctor && (
            <PopupSelect
              template={5}
              label={LANG_CONST.clinic_location}
              isPopover={true}
              defaultValue={false}
              isClearable={false}
              apiConfig={{
                url: isClinicDoctor ? 'hospital/list' : 'hospital/all',
                valueKey: 'hospital',
                labelKey: 'hospital',
                city: model.input('cityAddress'),
                userId: isClinicDoctor ? model.state.user?.clinicIds[0] : null
              }}
              placeholder={LANG_CONST.hospital}
              expandOptions={isClinicDoctor ? [] : [{ hospital: 'other' }]}
              name={'hospital'}
              value={model.input('hospital')}
              onChange={(n, v, o) => {
                if (v?.toString() === model.input('hospital')?.toString()) return;
                if (v !== 'other')
                  model.setStateSilent({
                    hospitalId: o?.item?.id,
                    cityAddress: o?.item?.city || '',
                    countryAddress: o?.item?.country || '',
                    stateAddress: o?.item?.state || ''
                  });
                model.handleChange(n, v);
              }}
            />
          )}
          {(model.input('hospital') === 'other' || !isClinicDoctor) && (
            <>
              <AutoCompleteField
                template={5}
                label={isClinicDoctor ? '' : LANG_CONST.clinic_location}
                name={'otherHospital'}
                value={model.input('otherHospital')}
                onChange={(n, v) => {
                  model.handleChange(n, v);
                  model.loadPlace(v);
                }}
                invalid={invalid}
                autocompleteApi='places'
                autocompleteParams={{
                  ...address,
                  limit: 20
                }}
              />
              {!!place && place.location && (
                <GoogleMaps
                  place={place}
                  lat={place.location.latitude}
                  lng={place.location.longitude}
                  zoom={16}
                />
              )}
            </>
          )}
          {!(place && place.location) && !!cityPlace && cityPlace.location && (
            <GoogleMaps
              place={cityPlace}
              lat={cityPlace.location.latitude}
              lng={cityPlace.location.longitude}
              zoom={10}
            />
          )}
          {invalid?.hospital && (
            <p className={'mc-form-invalid-text'}>{lang.t(invalid?.hospital)}</p>
          )}
        </div>
      </form>
    );
  };

  renderStep2 = () => {
    return (
      <div className={'mc-flex-col mc-grow'} style={{ padding: 0, minHeight: remCss(500) }}>
        <div className={'mc-flex mc-ptb10 mc-plr20 mc-bb'}>
          <SearchTextField
            template={'2'}
            width={300}
            onChange={managerModel.handleChangeSearch}
            value={managerModel.listInput('search')}
          />
        </div>
        <MCText
          label={LANG_CONST.text.select_manager_for_location}
          size={20}
          weight={500}
          style={{ paddingLeft: remCss(20) }}
          heading
        />
        <MCVirtuoso
          model={managerModel}
          itemContent={(index, item) => {
            const isOwner = item.id === item.managerToClinic;
            const managerAccess = managerModel.state.managerAccess || {};
            const isAllActive =
              !(!item.managerActive || item.id === managerModel.state.user?.id) &&
              (!managerAccess[item.id] || managerAccess[item.id]['active']);

            return (
              <div className={'mc-flex-col mc-ptb10 mc-plr20 mc-bb'}>
                <div className={'mc-flex'}>
                  <ShortInfo user={item} />
                  {isOwner ? (
                    <div className={'mc-text-420'}>{lang.t('Owner')}</div>
                  ) : (
                    <ToggleSwitch
                      className={!item.managerActive ? 'disabled' : ''}
                      disabled={!item.managerActive || item.id === managerModel.state.user?.id}
                      checked={isAllActive}
                      onChange={() => {
                        managerModel.setState({
                          managerAccess: {
                            ...managerAccess,
                            [item.id]: {
                              ...managerAccess[item.id],
                              active: !isAllActive
                            }
                          }
                        });
                      }}
                    />
                  )}
                </div>

                <div className={'mc-flex-col ' + (isAllActive ? '' : 'mc-hide')}>
                  {Object.keys(LANG_CONST.constants.manager_access).map((value) => {
                    let isActive = !['customerSupport', 'doctors'].includes(value);
                    if (managerAccess[item.id] && managerAccess[item.id][value] !== undefined) {
                      isActive = managerAccess[item.id][value];
                    }
                    return (
                      <div className={'mc-flex mc-flex-end'} key={value}>
                        <MCText
                          label={lang.t(LANG_CONST.text.handle_manager_access_in_location, {
                            access: lang.t(LANG_CONST.constants.manager_access[value]).toLowerCase()
                          })}
                          style={{ marginLeft: remCss(100) }}
                          flex
                        />
                        <ToggleSwitch
                          className={!item.managerActive ? 'disabled' : ''}
                          disabled={!item.managerActive || item.id === managerModel.state.user?.id}
                          checked={isActive}
                          onChange={() => {
                            managerModel.setState({
                              managerAccess: {
                                ...managerAccess,
                                [item.id]: {
                                  ...managerAccess[item.id],
                                  [value]: !isActive,
                                  active: true
                                }
                              }
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }}
        />
      </div>
    );
  };

  render() {
    const { model, addManager = false } = this.props;
    const { closeBtn } = this.props;
    const createState = model.getApiState(apiId);
    let loading = createState.loading || model.getApiState('check').loading;
    let managerLoading = managerModel.refreshing();

    return (
      <div className={'mc-popup-contain'} style={{ minWidth: remCss(600), height: '95%', maxHeight: remCss(1060) }}>
        <div className='mc-modal-header'>
          <div className='mc-title'>{lang.t('Add new location')}</div>
          {closeBtn}
        </div>
        {this.state.step === 1 ? this.renderStep1() : this.renderStep2()}
        {!!createState.errorMessage && (
          <div className='mc-error'>{lang.t(createState.errorMessage)}</div>
        )}
        <div className='mc-modal-footer mc-flex'>
          <MCButton
            className='mc-grow'
            primary
            light
            radius
            medium
            type={'button'}
            onClick={this.props.hide}
            disabled={loading}
          >
            {lang.t('Cancel')}
          </MCButton>

          {addManager && this.state.step === 1 && managerModel.items().length > 0 ? (
            <MCButton
              primary
              dark
              radius
              medium
              disabled={loading}
              loading={loading}
              className='mc-grow'
              onClick={() => {
                model.validRequest((valid) => {
                  if (valid) {
                    managerModel.reset(true);
                    managerModel.refresh();
                    this.setState({ step: 2 });
                  }
                });
              }}
              label={'Next'}
            />
          ) : (
            <MCButton
              primary
              dark
              radius
              medium
              disabled={managerLoading || loading}
              loading={loading}
              className='mc-grow'
              onClick={this.submit}
              label={'Add Location'}
            />
          )}
        </div>
      </div>
    );
  }
}
